import { fabric } from 'fabric';
import { handleOrderChange } from '../../drawer-container/utils/handle-order-change';
import { getOrderIndices } from '../../../../utils/canvas-utils/get-order-indices';
import { getSelectableObjectsIndices } from '../../../../utils/canvas-utils/get-selectable-objects-indices';

type ApplyOrderChangeOptions = {
  canvas?: fabric.Canvas | null;
  sliderValue: number;
  onComplete?: (newOrderIndex: number) => void;
};

/**
 * Translates a desktop order slider position into a canvas reorder action and
 * fires `onComplete` once the order change resolves.
 */
export const applyOrderChange = ({ canvas, sliderValue, onComplete }: ApplyOrderChangeOptions): void => {
  if (!canvas) {
    return;
  }

  const { objects } = getOrderIndices(canvas);
  const selectableIndices = getSelectableObjectsIndices(objects);
  const newOrderIndex = selectableIndices[`${sliderValue}`];

  handleOrderChange(newOrderIndex, canvas)
    .then(() => {
      onComplete?.(newOrderIndex);
    })
    .catch(() => {
      // Swallow the error: a failed reorder still needs the canvas to be
      // re-rendered (handled in the `finally` below) so the slider's
      // visual state stays in sync with reality.
    })
    .finally(() => {
      canvas.renderAll();
    });
};
